import PropTypes from 'prop-types';

import { ColumnTitle, Form, FormButtons, FormColumn, InputWarning } from './styles';
import Label from '../../ComponentLibrary/input-elements/oc-label';
import SelectDropdown from '../../ComponentLibrary/input-elements/oc-select-dropdown';
import TextInput from '../../ComponentLibrary/input-elements/oc-text-input';
import Button from '../../ComponentLibrary/oc-button';
import { connectLocation } from '../../location/LocationConnectors';

const QuietZoneForm = connectLocation(
  ({ projectLocation, projectSqFoot, isFormValid, onChange, resetForm, onCalculate, t }) => (
    <FormColumn>
      <ColumnTitle showBorderBottom>{t('insulation.commercial.quietzone.form.title')}</ColumnTitle>
      <Form onSubmit={onCalculate}>
        <div>
          <Label
            forId="projectLocation"
            text={t('insulation.commercial.quietzone.form.project_location')}
            helperText={
              <>
                {t('insulation.commercial.quietzone.form.project_location_helper')}
                <sup>#</sup>
              </>
            }
            helperTextColor="#585858"
          />
          <SelectDropdown
            required
            value={projectLocation}
            onChange={onChange}
            name="projectLocation"
            options={[
              { value: '', text: t('insulation.commercial.quietzone.form.project_location_placeholder') },
              { value: 'vancouver', text: 'Vancouver' },
              { value: 'calgary', text: 'Calgary' },
              { value: 'regina', text: 'Regina' },
              { value: 'winnipeg', text: 'Winnipeg' },
              { value: 'toronto', text: 'Toronto' },
              { value: 'montreal', text: 'Montreal' },
              { value: 'fredericton', text: 'Fredericton' },
              { value: 'halifax', text: 'Halifax' },
            ]}
          />
        </div>
        <div>
          <Label
            forId="projectSqFoot"
            text={t('insulation.commercial.quietzone.form.insulation_requirements')}
            helperText={t('insulation.commercial.quietzone.form.insulation_requirements_helper')}
            helperTextColor="#585858"
          />
          <TextInput
            required
            placeholder={t('insulation.commercial.quietzone.form.insulation_requirements_placeholder')}
            name="projectSqFoot"
            type="number"
            value={projectSqFoot}
            onChange={onChange}
          />
          <InputWarning>{t('insulation.commercial.quietzone.form.input_warning')}</InputWarning>
        </div>
        <FormButtons>
          <Button disabled={!isFormValid} onClick={onCalculate} data-track="calculate">
            {t('insulation.commercial.quietzone.form.cta')}
          </Button>
          <Button color="white" onClick={resetForm}>
            {t('insulation.commercial.quietzone.form.reset')}
          </Button>
        </FormButtons>
      </Form>
    </FormColumn>
  )
);

QuietZoneForm.propTypes = {
  projectLocation: PropTypes.string.isRequired,
  projectSqFoot: PropTypes.string.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  onCalculate: PropTypes.func.isRequired,
};

export default QuietZoneForm;
